import * as React from 'react';
import {Editor} from 'react-draft-wysiwyg';
import {
  ContentState,
  convertFromHTML,
  convertToRaw,
  EditorState,
} from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import 'styles/DraftJs.css';

export interface TextEditorProps {
  defaultValue?: string;
  onChange?(value: TextEditorProps['defaultValue']): void;
}

/**
 * The component add visual text editor
 * @param {TextEditorProps} props
 * @return {React.ReactElement<TextEditorProps>}
 * @constructor
 */
export default function TextEditor(
    props: TextEditorProps,
): React.ReactElement<TextEditorProps> {
  /**
   * This function will return default editor state.
   * @return {Draft.Model.ImmutableData.EditorState}
   */
  function getDefaultState(): EditorState {
    if (!props.defaultValue) return EditorState.createEmpty();
    return EditorState.createWithContent(
      ContentState.createFromBlockArray(
        htmlToDraft(
          props.defaultValue,
        ).contentBlocks,
      ),
    );
  }

  const [
    editorState,
    setEditorState,
  ] = React.useState<EditorState>(
      getDefaultState(),
  );

  /**
   * This state change event handler.
   * @param {EditorState} editorState
   */
  function handleStateChange(editorState: EditorState): void {
    setEditorState(editorState);
    props.onChange && props.onChange(
        draftToHtml(convertToRaw(editorState.getCurrentContent())),
    );
  }

  return (
    <Editor
      editorState={editorState}
      onEditorStateChange={handleStateChange}
      placeholder="Введите текст"
      toolbar={{
        options: [
          'inline',
          'blockType',
          'fontSize',
          'list',
          'textAlign',
          'link',
          'history'
        ],
      }}
    />
  );
}
